export const IMAGE_FILE_SUPPORTED_FORMATS = [
  "jpeg",
  "jpg",
  "png",
  "webp"
]

export const CUSTOMER_LOGO_FILE_SUPPORTED_FORMATS = [
  "jpeg",
  "jpg",
  "png",
  "webp",
  "svg"
]
